import { createStore } from 'vuex'
// vuex 持久化插件
import createPersistedState from 'vuex-persistedstate'
// 用户信息
import userStore from '@/store/modules/user.js'
// 全局配置管理（主题，样式，国际化）
import appStore from '@/store/modules/app_config.js'
import pathStore from '@/store/modules/path.js'
// 字典数据管理
import dictStore from '@/store/modules/dict.js'
const store = createStore({
  // modules 模块
  modules: {
    userStore,
    appStore,
    // 更多模块...
    pathStore,
    dictStore
  },
  // 全局
  state: {},
  // 全局
  mutations: {},
  // 全局
  actions: {},
  // 全局
  getters: {},
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths: ['userStore', 'appStore', 'pathStore', 'dictStore'],
    reducer (val) {
      return {
        userStore: val.userStore,
        appStore: val.appStore,
        pathStore: val.pathStore,
        dictStore: val.dictStore
      }
    }
  })]
})

export default store
